import { render, staticRenderFns } from "./MyPlanningKanban.vue?vue&type=template&id=66c02112&scoped=true"
import script from "./MyPlanningKanban.vue?vue&type=script&lang=js"
export * from "./MyPlanningKanban.vue?vue&type=script&lang=js"
import style0 from "./MyPlanningKanban.vue?vue&type=style&index=0&id=66c02112&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c02112",
  null
  
)

export default component.exports